import ACUTXLogo from './images/Footer_NCUA.png';
import Checkmark from './images/Checkmark.png';
import BankIcon from './images/Bank_Icon.png';
import PhoneIcon from './images/Phone_Icon.png';
import AppointmentIcon from './images/Appointment_Image.png';
import Logo from './images/logo.png';
import SlideShowImage from './images/Hero_Image.png';


export const IMAGES = {
  ACUTXLogo,
  Checkmark,
  BankIcon,
  PhoneIcon,
  Logo,
  SlideShowImage,
  AppointmentIcon,
};
